<template>
  <div>
    <TimerControl v-if="slide.settings.timer" @subcommand="subcommand"></TimerControl>
    <TeamStatusControl v-if="slide.settings.subject" :subject="slide.settings.subject" type="answers"></TeamStatusControl>
	  <div class="notice" v-if="!scenario">Er is geen scenario geselecteerd.</div>
  </div>
</template>

<script>
import BaseSlide from './BaseSlide';
import TimerControl from "../controls/TimerControl";
import TeamStatusControl from "../controls/TeamStatusControl";

export default {
	name: 'ScenarioSlide',
	mixins: [BaseSlide],
  components: {
	  TimerControl,
    TeamStatusControl,
  },
	computed: {
		scenario(){
			return this.$actions.getVariable('scenario');
		},
	},
};
</script>

<style></style>
